import { Helmet } from "react-helmet";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Alert,
  Box,
  Button,
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Chip,
  Container,
  Divider,
  Link,
  Grid,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Toolbar,
  Typography,
  tableCellClasses,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ApexCharts from "react-apexcharts";

import React, { useEffect } from "react";
import axios from "axios";
import CollapsibleTable from "../../../components/inbox/CollapsibleTable";
import { fetchPlanning, getCarryScore } from "../../../actions/planning";
import cssVariables from "../../../theme/cssVariables";
import { fetchMasterUnit } from "../../../actions/pickList";
import ListIcon from "../../../assets/icons/List";
import { Link as RouterLink } from "react-router-dom";
import DialogItemDetail from "../../../components/planning/DialogItemDetail";
import DialogItemWorkDetail from "../../../components/planning/DialogItemWorkDetail";
import LaunchIcon from "@mui/icons-material/Launch";
import { ReactComponent as Launch } from "../../../assets/images/launch.svg";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles, styled } from "@mui/styles";

import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar-month.svg";
import { ReactComponent as HourGlassIcon } from "../../../assets/icons/hourglass.svg";
import { ReactComponent as InfoIcon } from "../../../assets/icons/info.svg";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check-3.svg";
import { ReactComponent as CheckIcon2 } from "../../../assets/icons/check-2.svg";
import { ReactComponent as MarkIcon } from "../../../assets/icons/mark.svg";


function BarLegend(props) {
  const data = props.data;
  let row = [];
  for (var i = 0; i < data.series.length; i++) {
    row.push(
      <Box key={data.series[i].id} display="flex" alignItems="center">
        <Box sx={{ width: "5%" }}>
          <div
            className="bar-legend-circle"
            style={{ backgroundColor: data.options.colors[i] }}
          ></div>
        </Box>
        <Box sx={{ width: "45%" }}>
          <Typography fontSize="0.9rem" fontWeight="300"> {data.series[i].name}</Typography>
        </Box>
        <Box sx={{ width: "10%" }}>
          <Typography> {data.series[i].data[0]}</Typography>
        </Box>
        <Box sx={{ width: "20%" }}>
          <Typography fontSize="0.9rem" fontWeight="300"> {data.options.unit}</Typography>
        </Box>
        <Box sx={{ width: "10%" }}>
          <Typography fontWeight="300">({data.series[i].data[0]}%)</Typography>
        </Box>
      </Box>
    );
  }
  console.log(row);
  return row;
}

const InboxPlanningDetail = () => {
  const _ = require("lodash");
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // local state
  const [value, setValue] = React.useState("all");
  // redux state
  const planning = useSelector((state) => state.Planning);
  // group rubrics type
  const tabs = _.groupBy(planning.rubrics, function (loRow) {
    return loRow.rubricCat;
  });
  console.log(tabs, 213);
  useEffect(() => {
    dispatch(fetchPlanning());
    dispatch(fetchMasterUnit());
    getCarryScore();
  }, []);
  /** handle function*/
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const openDialog = (event, newValue) => {};
  // table customize
  const useStyles = makeStyles({
    root: {
      "border-width": 0,
      "padding-left": 0,
      [`&.${tableCellClasses.body}`]: {
        "border-width": 0,
        "padding-left": 0,
      },
    },
    iconContainer: {
      width: 40,
      height: 40,
      borderRadius: 5,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    profileContainer: {
      width: 70,
      height: 70,
      borderRadius: "50%",
      marginTop: 3,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    tab: {
      fontSize: "16px !important",
      fontWeight: "300 !important",
      "&.Mui-selected": {
        color: cssVariables.color.primary + " !important",
      },
    },
  });
  const styles = {
    greenBadge: {
      background: "rgb(186 217 87 / 15%)",
      padding: "5px",
      color: "#93AC41",
    },
    blockGrid: {
      padding: "38px 0 0 0",
    },
  };
  let chartOptions = {
    type: "bar",
    color: "#939393",
    series: [
      {
        name: "ภาระงานสอน",
        data: [20],
      },
      {
        name: "ภาระงานวิจัยและงานวิชาการอื่น",
        data: [60],
      },
      {
        name: "ภาระงานบริการวิชาการภายใน",
        data: [20],
      },
      {
        name: "ภาระงานบริการวิชาการภายนอก",
        data: [20],
      },
    ],
    options: {
      unit: "คะแนน",
      chart: {
        type: "bar",
        stacked: true,
        stackType: "100%",
        toolbar: {
          show: false,
        },
        offsetX: 0,
        offsetY: 0,
      },
      colors: [
        cssVariables.barChart.blue["200"],
        cssVariables.barChart.green["200"],
        cssVariables.barChart.orange["300"],
        cssVariables.barChart.orange["200"],
      ],
      plotOptions: {
        bar: {
          horizontal: true,
          // borderRadius: 20,
          barHeight: "100%",
        },
      },
      grid: {
        show: false,
        padding: {
          top: -50,
          right: 0,
          bottom: -10,
          left: -20,
        },
      },
      stroke: {
        width: 0,
        colors: ["#fff"],
      },
      xaxis: {
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + "K";
          },
        },
      },
      fill: {
        opacity: 1,
      },
      legend: {
        show: false,
        position: "bottom",
        horizontalAlign: "left",
        offsetX: -33,
        offsetY: -55,
        formatter: function (val, opts) {
          const roundToHundred = (arr) => {
            let output = [];
            let acc = 0;
            for (let i = 0; i < arr.length; i++) {
              let roundedCur = Math.round(arr[i][0]);
              const currentAcc = acc;
              if (acc == 0) {
                output.push(roundedCur);
                acc += arr[i][0];
                continue;
              }
              acc += arr[i][0];
              output.push(Math.round(acc) - Math.round(currentAcc));
            }
            return output;
          };
          let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
          return (
            "<span class='fs-12px ml-2'>" +
            (val ? val : "-") +
            ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
            (opts.w.globals.series[opts.seriesIndex]
              ? opts.w.globals.series[opts.seriesIndex]
              : 0) +
            " (" +
            (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0) +
            "%)" +
            "</span>"
          );
        },
      },
    },
  };
  const classes = useStyles();
  const vBoxPadding = 2;
  return (
    <>
      <Helmet>
        <title>รายละเอียดข้อตกลงภาระงาน | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={2} mt={1} mb={0}>
            <Grid item>
              <Typography
                variant="h2"
              >
                {/* {t("planning.label.myWorkload")} */}
                ข้อตกลงภาระงาน - สายวิชาการ ปีพ.ศ. 2565
              </Typography>
            </Grid>
            <Grid item xs="auto" ml="auto">
              <Box display="flex" sx={{ width: "fit-content" }}>
                <Button
                  color="red"
                  variant="contained"
                  fullWidth
                  startIcon={<MarkIcon />}
                  className="btn-large"
                  sx={{ marginRight: 1 }}
                >
                  ปฏิเสธ
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  fullWidth
                  startIcon={<CheckIcon2 />}
                  className="btn-large"
                >
                  อนุมัติ
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Grid container item pb={2} pt={2}>
            <Grid item xs sm md lg>
              <Card sx={{ height: 1 }}>
                <CardContent sx={{ px: 2 }}>
                  <Grid container mb={2}>
                    <Grid item lg={6} display="flex" alignItems="center">
                      <Typography variant="h3">ข้อตกลงภาระงาน</Typography>
                    </Grid>
                    <Grid item lg={6} display="flex" justifyContent="flex-end">
                      <Box
                        sx={{
                          background: "#5DA19626",
                          borderRadius: "4px",
                          border: "1px solid #5DA196",
                          width: "fit-content",
                          padding: "3px 10px",
                        }}
                      >
                        <Typography
                          fontSize={18}
                          fontWeight={500}
                          color="primary"
                        >
                          คะแนนยกยอดจากปีก่อน : 30 คะแนน
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid
                      item
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      mr={3}
                    >
                      <img
                        className={`${classes.profileContainer}`}
                        src="/exam-profile.png"
                        alt="profile"
                      />
                    </Grid>
                    <Grid item xs sm md lg>
                      <Grid container>
                        <Grid item>
                          <Typography variant="h5" color="primary">
                            รศ.ดร.ศรัณยู สิริชัย
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs sm md={1}>
                          <Typography variant="sub_label">
                            ระดับบุคลากร:
                          </Typography>
                        </Grid>
                        <Grid item xs sm md={4}>
                          <Typography>รองศาตราจารย์</Typography>
                        </Grid>
                        <Grid item xs sm md={1}>
                          <Typography variant="sub_label">
                            ตำแหน่งงาน:
                          </Typography>
                        </Grid>
                        <Grid item xs sm md={4}>
                          <Typography>อาจารย์</Typography>
                        </Grid>
                      </Grid>
                      <Grid container>
                        <Grid item xs sm md={1}>
                          <Typography variant="sub_label">สายงาน:</Typography>
                        </Grid>
                        <Grid item xs sm md={4}>
                          <Typography>สายวิชาการ</Typography>
                        </Grid>
                        <Grid item xs sm md={1}>
                          <Typography variant="sub_label">หน่วยงาน:</Typography>
                        </Grid>
                        <Grid item xs sm md={4}>
                          <Typography>คณะบริหารธุรกิจ</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
                <Divider variant="middle" />
                <CardContent sx={{ px: 2 }}>
                  <Grid container mt={0}>
                    <Grid
                      item
                      display="flex"
                      sx={{
                        flexFlow: "column",
                      }}
                    >
                      <Typography variant="h3">ภาพรวมข้อตกลงภาระงาน</Typography>
                    </Grid>
                  </Grid>
                  <Grid container mt={2} display="flex" alignItems="center">
                    <Grid item mr={1}>
                      <CalendarIcon></CalendarIcon>
                    </Grid>
                    <Grid item xs="auto" sm="auto" md="auto" mr={2}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="sub_label">
                          รอบข้อตกลงภาระงาน:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs sm md>
                      <Typography>สิงหาคม 2563 - กรกฎาคม 2564</Typography>
                    </Grid>
                  </Grid>
                  <Grid container mt={1} display="flex" alignItems="center">
                    <Grid item mr={1}>
                      <CalendarIcon></CalendarIcon>
                    </Grid>
                    <Grid item xs="auto" sm="auto" md="auto" mr={2}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="sub_label">
                          ส่งภายในวันที่:
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs sm md>
                      <Typography>30 กรกฎาคม 2564</Typography>
                    </Grid>
                  </Grid>
                  {/* status box */}
                  <Grid container mt={2}>
                    <Grid item xs sm md lg>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            minWidth: "380px",
                            height: "120px",
                            background: "rgba(93, 161, 150, 0.1)",
                            border: "1px solid #5DA196",
                            borderRadius: "5px",
                            position: "relative",
                          }}
                        >
                          <Box
                            sx={{ p: 1, display: "flex", alignItems: "center" }}
                          >
                            <Box
                              style={{
                                background: "#5DA196",
                                borderRadius: "50%",
                                width: "30px",
                                height: "30px",
                              }}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <CheckIcon></CheckIcon>
                            </Box>
                            <Box sx={{ ml: 2 }}>
                              <Typography fontSize="18" fontWeight="600">
                                จัดทำข้อตกลงภาระงาน
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              px: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              style={{
                                width: "30px",
                              }}
                            ></Box>
                            <Box sx={{ ml: 2 }}>
                              <Typography variant="h6" fontWeight="400">
                                สถานะ: อนุมัติเสร็จสิ้น
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              px: 1,
                              pb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              style={{
                                width: "30px",
                              }}
                            ></Box>
                            <Box sx={{ ml: 2 }}>
                              <Typography variant="h6" fontWeight="400">
                                วันที่ส่ง: 30 ก.ค. 64
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            style={{
                              position: "absolute",
                              right: 0,
                              top: 0,
                              margin: 6,
                            }}
                          >
                            <InfoIcon></InfoIcon>
                          </Box>
                        </div>
                        {/* connector */}
                        <div
                          style={{
                            border: "1px dashed #E5E5E5",
                            width: "100%",
                          }}
                        ></div>
                        <div
                          style={{
                            minWidth: "380px",
                            height: "120px",
                            background: "#F280261A",
                            border: "1px solid #F28026",
                            borderRadius: "5px",
                            position: "relative",
                          }}
                        >
                          <Box
                            sx={{ p: 1, display: "flex", alignItems: "center" }}
                          >
                            <Box
                              style={{
                                background: "#F28026",
                                borderRadius: "50%",
                                width: "30px",
                                height: "30px",
                              }}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <HourGlassIcon></HourGlassIcon>
                            </Box>
                            <Box sx={{ ml: 2 }}>
                              <Typography fontSize="18" fontWeight="600">
                                บันทึกภาระงาน
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              px: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              style={{
                                width: "30px",
                              }}
                            ></Box>
                            <Box sx={{ ml: 2 }}>
                              <Typography variant="h6" fontWeight="400">
                                สถานะ: ระหว่างการอนุมัติ
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              px: 1,
                              pb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              style={{
                                width: "30px",
                              }}
                            ></Box>
                            <Box sx={{ ml: 2 }}>
                              <Typography variant="h6" fontWeight="400">
                                วันที่ส่ง: 30 ก.ค. 64
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            style={{
                              position: "absolute",
                              right: 0,
                              top: 0,
                              margin: 6,
                            }}
                          >
                            <InfoIcon></InfoIcon>
                          </Box>
                        </div>
                        {/* connector */}
                        <div
                          style={{
                            border: "1px dashed #E5E5E5",
                            width: "100%",
                          }}
                        ></div>
                        <div
                          style={{
                            minWidth: "380px",
                            height: "120px",
                            background: "#FFFFFF",
                            border: "1px solid #DADADA",
                            borderRadius: "5px",
                            position: "relative",
                          }}
                        >
                          <Box
                            sx={{ p: 1, display: "flex", alignItems: "center" }}
                          >
                            <Box
                              style={{
                                background: "#FAFAFA",
                                borderRadius: "50%",
                                border: "1px dashed #C4C4C4",
                                width: "30px",
                                height: "30px",
                              }}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            ></Box>
                            <Box sx={{ ml: 2 }}>
                              <Typography
                                fontSize="18"
                                fontWeight="600"
                                sx={{ color: "#C4C4C4" }}
                              >
                                รับทราบผลข้อตกลงภาระงาน
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              px: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              style={{
                                width: "30px",
                              }}
                            ></Box>
                            <Box sx={{ ml: 2 }}>
                              <Typography
                                variant="h6"
                                fontWeight="400"
                                sx={{ color: "#C4C4C4" }}
                              >
                                สถานะ: ยังไม่ดำเนินการ
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              px: 1,
                              pb: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Box
                              style={{
                                width: "30px",
                              }}
                            ></Box>
                            <Box sx={{ ml: 2 }}>
                              <Typography
                                variant="h6"
                                fontWeight="400"
                                sx={{ color: "#C4C4C4" }}
                              >
                                วันที่ส่ง: -
                              </Typography>
                            </Box>
                          </Box>
                          <Box
                            style={{
                              position: "absolute",
                              right: 0,
                              top: 0,
                              margin: 6,
                            }}
                          >
                            <InfoIcon></InfoIcon>
                          </Box>
                        </div>
                      </Box>
                    </Grid>
                  </Grid>
                  {/* end status box */}
                  <Grid container mt={2}>
                    <Grid item xs sm md lg display="flex" alignItems="center">
                      <Box sx={{ mr: 1 }}><InfoIcon></InfoIcon></Box>
                      <Typography variant="label" sx={{ mr: 1 }}>
                        ขั้นตอนถัดไป:
                      </Typography>
                      <Typography variant="sub_label">ส่งอนุมัติจัดทำข้อตกลงภาระงานทางวิชาการประจำปี</Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item lg={6}>
              <Card sx={{ height: 1 }}>
                <CardContent sx={{ px: 2 }}>
                  <Grid container my={1}>
                    <Grid item lg={6}>
                      <Typography
                        fontSize={18}
                        fontWeight={500}
                        lineHeight="19.8px"
                      >
                        สัดส่วนแผนข้อตกลงภาระงาน
                      </Typography>
                    </Grid>
                    <Grid item lg={6}>
                      <Typography
                        fontSize={18}
                        fontWeight={500}
                        lineHeight="24.84px"
                        textAlign="right"
                        sx={{ color: "#939393" }}
                      >
                        100%
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item lg={12} xs={12}>
                      {/* <div> */}
                      <ApexCharts
                        options={chartOptions.options}
                        series={chartOptions.series}
                        type={chartOptions.type}
                        height="50px"
                      ></ApexCharts>
                      {/* </div> */}
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item lg={8} xs={12}>
                      <Grid container>
                        <Grid item lg={12}>
                          <BarLegend data={chartOptions}></BarLegend>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      lg={4}
                      xs={12}
                      display="flex"
                      alignItems="center"
                    >
                      <div style={styles.greenBadge}>
                        <Typography fontSize={14} lineHeight={1}>
                          โดยเป็นคะแนนสะสมจากปีก่อน 5 คะแนน
                          {/*{t("home.label.detail")}*/}
                        </Typography>
                      </div>
                    </Grid>
                  </Grid>
                </CardContent>
                <Divider variant="middle" />
                <CardActions sx={{ px: 2 }}>
                  <Grid container mt={0}>
                    <Grid
                      item
                      display="flex"
                      justifyContent="flex-end"
                      sx={{
                        flexFlow: "column",
                        marginLeft: "auto",
                      }}
                    >
                      <Typography
                        fontSize={16}
                        lineHeight="24px"
                        fontWeight={500}
                        textAlign="right"
                        sx={{ color: "#939393" }}
                      >
                        {/* {t("home.label.title")} */}
                        คะแนนสะสมรวมปัจจุบัน:{" "}
                        <span
                          className={classes.styleScroll}
                          style={{
                            marginLeft: "10px",
                            color: cssVariables.color.primary,
                          }}
                        >
                          100
                        </span>{" "}
                        คะแนน
                      </Typography>
                      <Typography
                        fontSize={11}
                        lineHeight="16.5px"
                        textAlign="left"
                        sx={{ color: "#939393" }}
                      >
                        {/* {t("home.label.title")} */}
                        (ภาระงานขั้นต่ำ 100 คะแนน)
                      </Typography>
                    </Grid>
                  </Grid>
                </CardActions>
              </Card>
            </Grid>
            <Grid item lg={6}>
              <Card sx={{ height: 1, px: 1 }}>
                <Box px={2} style={{ height: "100%" }}>
                  <CardContent
                    className={classes.cardContentSize}
                    sx={{
                      justifyContent: "flex-start",
                      alignItems: "flex-start",
                      padding: "10px 0",
                    }}
                  >
                    <Grid container my={1}>
                      <Grid item lg={6} xs={6}>
                        <Typography variant="label">
                          หลักเกณฑ์และเงื่อนไข
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="sub_label">ต่ำสุด</Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="sub_label">สูงสุด</Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="sub_label">
                          สัดส่วนที่ได้
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container my={2}>
                      <Grid item lg={12} xs={12}>
                        <Divider />
                      </Grid>
                    </Grid>
                    <Grid container my={2}>
                      <Grid item lg={6} xs={6}>
                        <Typography variant="label" fontWeight={400}>
                          ภาระงานสอน
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          15
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          45
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" color="primary">
                          15
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container my={2}>
                      <Grid item lg={6} xs={6}>
                        <Typography variant="label" fontWeight={400}>
                          ภาระงานวิจัยและงานวิชาการอื่น
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          40
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          -
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" color="primary">
                          65
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container my={2}>
                      <Grid item lg={6} xs={6}>
                        <Typography variant="label" fontWeight={400}>
                          ภาระงานสอนและภาระงานวิจัย และงานวิชาการอื่นๆ
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          85
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          -
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" color="primary">
                          80
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container my={2}>
                      <Grid item lg={6} xs={6}>
                        <Typography variant="label" fontWeight={400}>
                          ภาระงานบริการวิชาการภายใน
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          10
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          -
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" sx={{ color: "#FFBF49"}}>
                          5
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid container my={2}>
                      <Grid item lg={6} xs={6}>
                        <Typography variant="label" fontWeight={400}>
                          ภาระงานบริการวิชาการทั้งหมด
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          20
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" fontWeight={400}>
                          -
                        </Typography>
                      </Grid>
                      <Grid item lg={2} xs={2} textAlign="center">
                        <Typography variant="label" color="primary">
                          10
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Box>
              </Card>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item lg={12} md={12}>
              <Grid container>
                <Grid item md={12} my={5}>
                  <Divider />
                </Grid>
              </Grid>
              <Grid container>
                <Grid item md={12} display="flex" alignItems="center">
                  <div className={`${classes.iconContainer} ${classes.blueBg}`}>
                    <ListIcon />
                  </div>
                  <Typography
                    variant="h2"
                    fontSize={30}
                    lineHeight="33px"
                    color="#404349"
                    sx={{ ml: 3 }}
                  >
                    {/* {t("planning.label.workloadReport")} */}
                    จัดทำข้อตกลงภาระงาน
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item pb={2} pt={2} alignItems="center">
                <Grid item md={12}>
                  <Tabs
                    value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChange}
                    TabIndicatorProps={{
                      style: {
                        height: "8px",
                      },
                    }}
                  >
                    <Tab
                      label={
                        <span className={classes.root}>
                          {t("label.all")} (5)
                        </span>
                      }
                      value="all"
                      classes={{ root: classes.tab }}
                    />
                    {Object.keys(tabs).map((loRow) => {
                      let count = tabs[loRow][0]["items"]?.length ?? 0;
                      return (
                        <Tab
                          label={`${t("planning.label." + loRow)} (${count})`}
                          value={loRow}
                          classes={{ root: classes.tab }}
                        />
                      );
                    })}
                  </Tabs>
                  <Divider />
                </Grid>
              </Grid>
              {Object.keys(tabs).map((loRow, index) => (
                <>
                  <Grid
                    container
                    spacing={5}
                    sx={{
                      display:
                        value === loRow || value === "all" ? "block" : "none",
                    }}
                  >
                    <Grid item lg={12}>
                      <Toolbar
                        color="primary"
                        sx={{
                          "background-color":
                            chartOptions.options.colors[index],
                        }}
                      >
                        <Box>
                          <Typography
                            variant="h4_hilight"
                            sx={{ color: "white" }}
                          >
                            {t("planning.label." + loRow)}
                          </Typography>
                        </Box>
                        <Box sx={{ flexGrow: 1 }} />
                      </Toolbar>
                      <CollapsibleTable
                        data={tabs[loRow][0]["items"]}
                        rubricCat={loRow}
                      />
                      <Toolbar sx={{ display: "flex", alignItems: "start" }}>
                        <Box sx={{ flexGrow: 1 }} />
                        <Typography
                          variant="h6"
                          color={cssVariables.color.black}
                          fontSize={18}
                        >
                          {t("planning.label." + loRow + "TotalScore")}:
                        </Typography>
                        <Typography
                          variant="h6"
                          color={cssVariables.color.black}
                          mx={2}
                          fontSize={18}
                        >
                          15
                        </Typography>
                        <Typography
                          variant="h6"
                          color={cssVariables.color.black}
                          fontSize={18}
                        >
                          {t("label.score")}
                        </Typography>
                      </Toolbar>
                    </Grid>
                  </Grid>
                </>
              ))}
              <Grid container>
                <Grid item>
                  <Alert
                    icon={false}
                    sx={{ color: "#EFAD0A", background: "#EFAD0A1A" }}
                  >
                    <Typography>
                      • คะแนนภาระงานบริการวิชาการภายในต่ำกว่าหลักเกณฑ์กำหนด
                    </Typography>
                  </Alert>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default InboxPlanningDetail;
